import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-devops-roadmap',
  templateUrl: './devops-roadmap.component.html',
  styleUrls: ['./devops-roadmap.component.sass']
})
export class DevopsRoadmapComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
